import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Paper,
  IconButton,
  Grid,
  FormControlLabel,
  RadioGroup,
  FormControl,
  Radio
} from '@material-ui/core';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';

import { addDays } from 'date-fns';
import DateFnsUtils from '@date-io/date-fns';

import i18n from '../../i18n';
import { DATE_PICKER_OPTION } from '../../constants/general';
import '../../assets/stylesheets/ScheduleView.css';

class DashboardDatePicker extends Component {
  render() {
    const {
      startOfSelectedDate,
      onChange,
      onSelectPreviousRange,
      onSelectNextRange,
      handleDateRangeChange,
      selectedRangeType,
      daysInRange,
      onChangeCustomStartDate,
      onChangeCustomEndDate
    } = this.props;

    const customEndDate = addDays(startOfSelectedDate, daysInRange);

    return (
      <Paper className="blockContainer">
        <Grid container>
          {selectedRangeType !== DATE_PICKER_OPTION.CUSTOM ? (
            <>
              <Grid item xs={2} className="customGridItem">
                <IconButton
                  onClick={onSelectPreviousRange}
                  aria-label={i18n.t('schedule:showPreviousWeek')}
                >
                  <KeyboardArrowLeft color="secondary" />
                </IconButton>
              </Grid>
              <Grid item xs={8}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DatePicker
                    className="weekDatePicker"
                    value={startOfSelectedDate}
                    label={i18n.t('dashboard:selectRange')}
                    onChange={onChange}
                    format="d MMM yyyy"
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={2} className="customGridItem">
                <IconButton
                  onClick={onSelectNextRange}
                  aria-label={i18n.t('schedule:showNextWeek')}
                >
                  <KeyboardArrowRight color="secondary" />
                </IconButton>
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={6}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DatePicker
                    className="weekDatePicker"
                    value={startOfSelectedDate}
                    label={i18n.t('dashboard:from')}
                    onChange={onChangeCustomStartDate}
                    format="d MMM yyyy"
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={6}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DatePicker
                    className="weekDatePicker"
                    value={customEndDate}
                    label={i18n.t('dashboard:to')}
                    onChange={onChangeCustomEndDate}
                    format="d MMM yyyy"
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </>
          )}
        </Grid>
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <RadioGroup
              row
              aria-label="position"
              name="position"
              value={selectedRangeType}
              onChange={event => handleDateRangeChange(event.target.value)}
            >
              <FormControlLabel
                value={DATE_PICKER_OPTION.WEEKLY}
                control={<Radio color="secondary" />}
                label={i18n.t('dashboard:weekly')}
                labelPlacement="bottom"
              />
              <FormControlLabel
                value={DATE_PICKER_OPTION.MONTHLY}
                control={<Radio color="secondary" />}
                label={i18n.t('dashboard:monthly')}
                labelPlacement="bottom"
              />
              <FormControlLabel
                value={DATE_PICKER_OPTION.QUARTERLY}
                control={<Radio color="secondary" />}
                label={i18n.t('dashboard:quarterly')}
                labelPlacement="bottom"
              />
              <FormControlLabel
                value={DATE_PICKER_OPTION.CUSTOM}
                control={<Radio color="secondary" />}
                label={i18n.t('dashboard:custom')}
                labelPlacement="bottom"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Paper>
    );
  }
}

DashboardDatePicker.propTypes = {
  startOfSelectedDate: PropTypes.instanceOf(Date).isRequired,
  onChange: PropTypes.func.isRequired,
  onSelectPreviousRange: PropTypes.func.isRequired,
  onSelectNextRange: PropTypes.func.isRequired,
  handleDateRangeChange: PropTypes.func.isRequired,
  selectedRangeType: PropTypes.string.isRequired,
  daysInRange: PropTypes.number.isRequired,
  onChangeCustomStartDate: PropTypes.func.isRequired,
  onChangeCustomEndDate: PropTypes.func.isRequired
};

export default DashboardDatePicker;
